/**
 * Create a default sort for ReactTable
 */
export const setDefaultTableSort = (sort) => {
    let sortArray = [];
    let sortObject = {};
    if (sort && sort.field) {
        if (sort.field) {
            sortObject.id = sort.field;
        }
        if (sort.order) {
            sortObject.desc = (sort.order === 'DESC');
        }
        sortArray.push(sortObject);
    }
    return sortArray;
};

/**
 * Get current ReactTable state (for sorting and filtering)
 *
 * @param table
 * @return {*}
 */
export const getTableState = (table) => {
    const tableState = table.getResolvedState();
    if (tableState) {
        const tableData = tableState.sortedData;
        if (tableData && tableData.length > 0) {
            return tableData;
        }
    }
    return [];
};

/**
 * Filter number or string columns (case-insensitive)
 *
 * @param filter
 * @param row
 * @return {boolean}
 */
export const filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    if (row[id] !== null && typeof row[id] === 'string') {
        return (
            (row[id] !== undefined)
                ? String(row[id].toLowerCase()).indexOf(filter.value.toLowerCase()) !== -1
                : true
        )
    } else {
        return (
            String(row[filter.id]).indexOf(filter.value) !== -1
        )
    }
};

/**
 * Sort date strings by format
 *
 * @param a
 * @param b
 * @param format
 * @param separator
 * @param sortOrder
 * @return {number}
 */
export const sortDate = (a, b, format = 'mm-dd-yyyy', separator = '-', sortOrder = 'ASC') => {
    let aArr = a.split(separator);
    let baArr = b.split(separator);
    let aComp, bComp;
    if (format === 'mm-dd-yyyy') {
        aComp = aArr[2] + separator + aArr[0] + separator + aArr[1];
        bComp = baArr[2] + separator + baArr[0] + separator + baArr[1];
        return (sortOrder === 'DESC') ? bComp - aComp : aComp - bComp;
    }
    return (sortOrder === 'DESC') ? b - a : a - b;
};

/**
 * Sort numbers
 *
 * @param a
 * @param b
 * @param sortOrder
 * @return {number}
 */
export const sortNumber = (a, b, sortOrder = 'ASC') => {
    return (sortOrder === 'DESC') ? b - a : a - b;
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/tableFunctions.js